import { connect } from 'react-redux';
import { IBuildersInfoProps, BuildersInfo } from '../../components/BuildersInfo';
import { getBuilders, getSellers, getNewbuildingDisplayName, getIsLeadFactory } from '../../selectors/newbuilding';
import { IApplicationState } from '../../types/redux';
import { trackShowPhone } from '../../actions/analytics';
import { getNewbuildingId } from '../../selectors/newbuilding/getNewduildingId';
import { TThunkDispatch } from '../../types/redux/thunk';

type TBuildersInfoStateProps = Pick<
  IBuildersInfoProps,
  'builders' | 'sellers' | 'newbuildingDisplayName' | 'newbuildingId' | 'isLeadFactory'
>;

type TBuildersInfoDispatchProps = Pick<IBuildersInfoProps, 'trackActionOpenContactsCall'>;

export function mapStateToProps(state: IApplicationState): TBuildersInfoStateProps {
  return {
    newbuildingId: getNewbuildingId(state),
    builders: getBuilders(state),
    sellers: getSellers(state),
    isLeadFactory: getIsLeadFactory(state),
    newbuildingDisplayName: getNewbuildingDisplayName(state),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TBuildersInfoDispatchProps {
  return {
    trackActionOpenContactsCall: () => {
      // расхлоп
      dispatch(trackShowPhone('Open_jk_card_blockDeveloper'));
    },
  };
}

export const BuildersInfoContainer = connect(mapStateToProps, mapDispatchToProps)(BuildersInfo);
